import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import { Fetchexecutequery } from '../../../services/demo/brs/brsService1';

import Modal from 'react-bootstrap/Modal';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'semantic-ui-css/semantic.min.css';
import { Button } from 'semantic-ui-react';
import * as XLSX from 'xlsx';
import axios from "axios";

const SingleBarChart = ({ query, headers, data, seriesLabel = "Book" }) => {
  const [clickedData, setClickedData] = useState(null);
  const [show, setShow] = useState(false);
  const [extGridData, setExtGridData] = useState([]);
  const [modelcolumnnames, setModelColumnNames] = useState([]);
  const [filterValue, setFilterValue] = useState('');

  const handleClose = () => {
    setShow(false);
    setFilterValue('');
  };

  useEffect(() => {
    if (filterValue) {
      fetchData(filterValue);
    }
  }, [filterValue]);

  function fetchData(filterValue) {
    setExtGridData([]);
    const dynamicQuery = query.replace('${filterValue}', filterValue);

    const payload = { query: dynamicQuery };
    const getProcessingLayerDataWithStatus = Fetchexecutequery();

    axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then((response) => {
        setExtGridData(response.data);
        setShow(true);
      })
      .catch((error) => {
        console.error("Data fetch error:", error);
      });
  }

  const intColumnDefs = React.useMemo(() => {
    if (extGridData?.length > 0) {
      const keys = Object.keys(extGridData[0]);
      const columns = keys.map((key) => ({
        headerName: key,
        field: key,
        sortable: true,
        filter: true,
        resizable: true,
      }));
      setModelColumnNames(columns);
      return columns;
    }
    return [];
  }, [extGridData]);

  const exportJsonToXLSX = (data, sheetName, fileName) => {
    try {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, fileName);
    } catch {
      return false;
    }
  };

  const exportToExcel = () => {
    const excelData = extGridData.map(row => {
      const formatted = {};
      modelcolumnnames.forEach(col => {
        formatted[col.headerName] = row[col.field];
      });
      return formatted;
    });
    exportJsonToXLSX(excelData, "Sheet1", "SingleBarGraph_Report.xlsx");
  };

  const options = {
    chart: {
      toolbar: { show: false },
      events: {
        dataPointSelection: (event, chartContext, config) => {
          const value = config.w.config.series[0].data[config.dataPointIndex];
          const category = config.w.config.xaxis.categories[config.dataPointIndex];

          setFilterValue(category);
          setClickedData({ value, category });
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
        endingShape: 'rounded',
      },
    },
    tooltip: {
  shared: true,       // ? triggers tooltip when hovering anywhere in group
  intersect: false,
      y: {
        formatter: val => (val / 1e5).toFixed(2) + ' L',
      },
    },
    xaxis: {
      categories: headers,
    },
    yaxis: {
      title: { text: 'Amount (in Crores)' },
      labels: {
        formatter: val => (val / 1e5).toFixed(2) + ' L',
      },
    },
    dataLabels: { enabled: false },
  };

  const series = [
    {
      name: seriesLabel,
      data: data,
      color: '#FF5733',
    },
  ];

  return (
    <div>
      <Chart options={options} series={series} type="bar" height={250} />

      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{filterValue}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex justify-content-end mb-2'>
            <Button icon="file excel" color="green" onClick={exportToExcel} />
          </div>
          <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
            <AgGridReact
              columnDefs={modelcolumnnames}
              rowData={extGridData}
              pagination={true}
              paginationPageSize={10}
              animateRows={true}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SingleBarChart;
